import { getBrowserDetails } from './browser.util.service';

export const getBrowser = (window) => getBrowserDetails(window);
export const getBrowserInfo = (window) => getBrowser(window) || {}; // { name, version, versionString }

export const getBrowserName = (window) => {
  // Edge case for Edge (HEH!) since includes Chrome & Safari in user agent
  const userAgent = getUserAgent(window);
  if (userAgent.indexOf('Edge') !== -1) {
    return 'Edge';
  }
  // Facebook in app browser
  if (userAgent.indexOf('FBAN') !== -1 || userAgent.indexOf('FBAV') !== -1) {
    return 'Facebook';
  }
  // IG
  if (userAgent.indexOf('Instagram') !== -1) {
    return 'Instagram';
  }
  return getBrowserInfo(window).name;
};

export const getOSInfo = (window) => {
  if (window.browserInfo === undefined) {
    return {};
  }
  return window.browserInfo.os || {}; // { name, versionString }
};

export const getOSName = () => getOSInfo().name;

export const getUserAgent = (window) => window.navigator.userAgent;

export const detectDeviceType = ({ win = window, strict = false }) => {
  const { userAgent, userAgentData } = win.navigator;

  const screenWidth = win.innerWidth;
  const isStrict = strict ? userAgentData?.mobile : true;
  const MAX_TABLET_WIDTH = 1024;
  const isMobile = screenWidth <= MAX_TABLET_WIDTH && isStrict;

  let deviceSpecs = {
    value: undefined,
    meterType: undefined,
    meterTag: undefined,
  };

  const phoneTypes = Object.freeze({
    Android: {
      regex: /Android/gim,
      value: 'Android',
      meterType: 'usb',
      meterTag: 'Duo C',
    },
    iPad: {
      regex: /iPad/gim,
      value: 'iPhone',
      meterType: 'lightning',
      meterTag: 'Duo',
    },
    iPhone: {
      regex: /iPhone/gim,
      value: 'iPhone',
      meterType: 'lightning',
      meterTag: 'Duo',
    },
  });

  if (isMobile) {
    const result = Object.keys(phoneTypes).find((value) =>
      userAgent.match(phoneTypes[value].regex)
    );

    if (result) {
      const { value, meterType, meterTag } = phoneTypes[result];
      deviceSpecs = {
        value,
        meterType,
        meterTag,
      };
    }
  }

  return deviceSpecs;
};
